"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoByProvId = exports.editProvLogo = exports.addProvLogo = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 新增网站省份logo
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var addProvLogo = exports.addProvLogo = function addProvLogo(data) {
  return _api.default.request({
    url: '/web/insertWebConfig',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑省份logo
 * @author kkdy
 * @date 2021-12-14
 * @param {any} data
 * @returns {any}
 */
var editProvLogo = exports.editProvLogo = function editProvLogo(data) {
  return _api.default.request({
    url: '/web/updateWebConfig',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据省Id获取网站logo配置
 * @author kkdy
 * @date 2021-12-14
 * @param {any} data
 * @returns {any}
 */
var logoByProvId = exports.logoByProvId = function logoByProvId(data) {
  return _api.default.request({
    url: '/web/getWebConfigByProvinceId',
    method: 'post',
    data: data
  });
};